import React from "react";
import TrackerMap from "./TrackerMap";

export type MapDiagnosticProps = { locale: "en-GB" | "da-DK"; color: string };

// The web preview cannot execute the native Google Maps SDK.
export default function MapDiagnostic(props: MapDiagnosticProps) {
  return <TrackerMap position={null} {...props} />;
}
